/* STEFANO - JS globale (tutto il sito) */
(function () {
  /* Menu drawer: i link ad ancore della pagina corrente chiudono il drawer e scorrono alla sezione */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.header-drawer a');
    if (!link) return;

    var url;
    try {
      url = new URL(link.href);
    } catch (e) {
      return;
    }

    if (!url.hash || url.origin !== location.origin || url.pathname !== location.pathname) return;

    event.preventDefault();

    var drawer = document.querySelector('header-drawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();

    var target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (target) {
      setTimeout(function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    }
  });

  /* Globo: nasconde le opzioni prodotto quando "Aggiungi al carrello" è disabilitato (prodotto esaurito) */
  var scheduled = false;

  function syncGloboOptions() {
    scheduled = false;

    var containers = document.querySelectorAll('.gpo-container');
    var addButton = document.querySelector('button[name="add"]');
    if (!containers.length || !addButton) return;

    var display = addButton.disabled ? 'none' : 'block';
    containers.forEach(function (container) {
      if (container.style.display !== display) container.style.display = display;
    });
  }

  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(syncGloboOptions);
  }

  function initGlobo() {
    syncGloboOptions();
    new MutationObserver(scheduleSync).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGlobo);
  } else {
    initGlobo();
  }
})();
